import { createEntityActions } from 'modules/redux-store';

export const clientAction = createEntityActions<'clients', Client>('clients');
